export const settings = 'settings';
export const tree = 'tree';

export default {
  settings,
  tree
};
